import { CheckNotes, InspectionCase } from '../inspection-cases';

export class FirefightersPhoneDto extends InspectionCase {
  item_13_1?: InspectionCase;
  item_13_2?: InspectionCase;
  item_13_3?: InspectionCase;
  item_13_4?: InspectionCase;
  item_13_5?: InspectionCase;
  item_13_6?: InspectionCase;
  item_13_7?: InspectionCase;
  item_13_8?: InspectionCase;
  item_13_9?: InspectionCase;
  item_13_10?: InspectionCase;
}

export class FirefightersPhone extends FirefightersPhoneDto {
  constructor(data: FirefightersPhoneDto = { title: 'טלפון כבאים' }) {
    super(data);
    this.item_13_1 = new InspectionCase({
      ...data.item_13_1,
      title: `כל הקווים מבוקרים ומוגנים, יהיה חיווי על מצב השפופרת`
    });
    this.item_13_2 = new InspectionCase({
      ...data.item_13_2,
      title: `אפשרות דיבור בו זמנית עם 5 שלוחות, כמו כן לבדוק כל שקע בנפרד`
    });
    this.item_13_3 = new InspectionCase({
      ...data.item_13_3,
      title: `בכל קומה יהיה שקע התחברות, בלובי הכניסה, ובלובי המעליות`
    });
    this.item_13_4 = new InspectionCase({
      ...data.item_13_4,
      title: `טלפון קבוע יותקן במקומות הבאים: חדר מכונות, חדר מעלית, חדר משאבות, חדר גנרטור חרום ומבואות הכניסה לבניין`
    });
    this.item_13_5 = new InspectionCase({
      ...data.item_13_5,
      title: `המערכת תצויד בזיהוי מיקום המתקשר, לחליפין ניתן לסמן בסימון בר קיימא את המיקום`
    });
    this.item_13_6 = new InspectionCase({
      ...data.item_13_6,
      title: `בלובי במבנה יותקן עמדה שבה מאוכסנים שפורפרות הטלפונים`
    });
    this.item_13_7 = new InspectionCase({
      ...data.item_13_7,
      title: `דרוש את החלטת שירותי כבאות לגבי מיקום וכמות של שקעי טלפון כבאים`
    });
    this.item_13_8 = new InspectionCase({
      ...data.item_13_8,
      title: `מיקום טלפון כבאים ו-5 אפרכסות ימוקמו ליד לובי הכניסה/ קבלה`
    });
    this.item_13_9 = new InspectionCase({
      ...data.item_13_9,
      title: `יש לבדוק שקיימים בלובי הכניסה קופסא עם 5 אפרכסות`
    });
    this.item_13_10 = new InspectionCase({
      ...data.item_13_10,
      title: `הציוד נושא לפחות תקן ישראלי`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_13_1.isApplicable || this.item_13_1.isPassed) &&
        (!this.item_13_2.isApplicable || this.item_13_2.isPassed) &&
        (!this.item_13_3.isApplicable || this.item_13_3.isPassed) &&
        (!this.item_13_4.isApplicable || this.item_13_4.isPassed) &&
        (!this.item_13_5.isApplicable || this.item_13_5.isPassed) &&
        (!this.item_13_6.isApplicable || this.item_13_6.isPassed) &&
        (!this.item_13_7.isApplicable || this.item_13_7.isPassed) &&
        (!this.item_13_8.isApplicable || this.item_13_8.isPassed) &&
        (!this.item_13_9.isApplicable || this.item_13_9.isPassed) &&
        (!this.item_13_10.isApplicable || this.item_13_10.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_13_1.getNotes(),
      ...this.item_13_2.getNotes(),
      ...this.item_13_3.getNotes(),
      ...this.item_13_4.getNotes(),
      ...this.item_13_5.getNotes(),
      ...this.item_13_6.getNotes(),
      ...this.item_13_7.getNotes(),
      ...this.item_13_8.getNotes(),
      ...this.item_13_9.getNotes(),
      ...this.item_13_10.getNotes()
    ];
  }
}
